import axios, { AxiosPromise } from 'axios';

export interface CustomerData {
    custom_field: String;
    email: String;
    name: String;
    signature: String;
}

class ReferralsService {
    static getSignature(): AxiosPromise<CustomerData> {
        return axios({
            method: 'GET',
            url: `${process.env.VUE_APP_API_URL}v1/communication/referrals/signature`,
        });
    }
}

export default ReferralsService;
